module.exports = __webpack_public_path__ + "img/status_0.9fe2d969.png";